import { RootEpic } from 'app/app.epics.type';
import { logSlice } from 'logic/store/log/log.slice';
import { initialize } from 'redux-form';
import { combineEpics } from 'redux-observable';
import { from, pipe, of } from 'rxjs';
import { filter, map, switchMap, throttleTime } from 'rxjs/operators';
import {
  UPDATE_EMAIL_FORM_NAME,
  validateUpdateEmailForm,
} from 'src/pages-all/user/user-profile/components/email-section/update-email.logic';
import { UserUpdateRequest } from '../../../api-models/api-models';
import { translate, translationKeys } from '../../../translations/translations.service';
import { normalizeEmail } from '../../../utils/email';
import { API_MULTIPLY_CALLS_TIMEOUT_MS } from '../../const';
import { getAuthenticatedUser } from '../authentication.selectors';
import { authenticationSlice } from '../authentication.slice';

const updateEmailInitialize$: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(authenticationSlice.actions.updateEmailInitialize.match),
    map(() =>
      initialize(UPDATE_EMAIL_FORM_NAME, {
        emailId: getAuthenticatedUser(state$.value)?.emailId,
      })
    )
  );

const updateEmail$: RootEpic = (
  action$,
  state$,
  { managed, ofValidReduxForm, authenticationApi, badRequestFormErrorHandler }
) =>
  action$.pipe(
    filter(authenticationSlice.actions.updateEmail.match),
    ofValidReduxForm(UPDATE_EMAIL_FORM_NAME, validateUpdateEmailForm),
    throttleTime(API_MULTIPLY_CALLS_TIMEOUT_MS),
    managed(
      authenticationSlice.actions.updateEmail,
      pipe(
        switchMap((action) => {
          const userId = getAuthenticatedUser(state$.value)?._id || '';
          const request: UserUpdateRequest = {
            emailId: normalizeEmail(action.payload.emailId),
          };
          return from(authenticationApi.updateUser(userId, request));
        })
      ),
      [badRequestFormErrorHandler(UPDATE_EMAIL_FORM_NAME)]
    ),
    switchMap((response) =>
      of(
        authenticationSlice.actions.setUser({ user: response.data.data }),
        logSlice.actions.logSuccess({
          message: translate(translationKeys.confirmation.weHaveSentYouConfirmationEmail),
        })
      )
    )
  );

export const emailEpics$ = combineEpics(updateEmailInitialize$, updateEmail$);
